import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import routes from "./routes";
import Preloader from "./components/Preloader/Preloader";

const INTEREST_KEY = "jst-last-interests";

function trackPath(pathname) {
  const p = pathname.toLowerCase();
  let tag = null;
  if (p.startsWith("/service")) tag = "services";
  else if (p.startsWith("/products")) tag = "products";
  else if (p.includes("industr")) tag = "industries";
  else if (
    p.includes("who-we-are") ||
    p.includes("our-team") ||
    p.includes("careers")
  )
    tag = "about";
  if (!tag) return;
  try {
    const prev = JSON.parse(localStorage.getItem(INTEREST_KEY) || "[]");
    const next = [tag, ...prev.filter((x) => x !== tag)].slice(0, 6);
    localStorage.setItem(INTEREST_KEY, JSON.stringify(next));
  } catch (e) {
    /* ignore */
  }
}

function RouteInterestTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPath(pathname);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  return (
    <Suspense fallback={<Preloader />}>
      <RouteInterestTracker />
      <Switch>
        {routes.map((props) => (
          <Route key={props.path ?? "__fallback__"} {...props} />
        ))}
      </Switch>
    </Suspense>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
